import { useEffect, useState } from "react";
import { _Entailment } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { Modal } from "../../../theme/Component/Modal";
import { Singleton } from '../../../../core/services/Singleton';
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { toast } from "react-toastify";
import { _AccountantIDForPayeable } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { ButtonAccountantTree } from "./ButtonAccountantTree";
import { Selecttofile } from "../../../Talentohumano/GestionTH/PaymentAccount/Selecttofile";
import { SelectTypeProcees } from "../../../Talentohumano/GestionTH/PaymentAccount/SelectTypeProcees";
import { SelectAccountantTree } from "./SelectAccountantTree";
import { BasicButton } from "../../../theme/Component/BasicButton";



export const AccountantIDForPayeable = () => {

    const AccountantIDForPayeable = useDataBean(_AccountantIDForPayeable);
    const single = Singleton.getInstance();
    const [IDPaymentFile, setIDPaymentFile] = useState<number>(null)
    const [ProcessType, setProcessType] = useState<number>(null)
    const [AccountantID, setAccountantID] = useState<any>(null)
    const [lista, setLista] = useState<any>([]);
    const [appoGroup, setAppoGroup] = useState<number>(null)
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    // useEffect(() => {
    //     getLista();
    // }, [])

    const getLista = () => {

        AccountantIDForPayeable.instance.getAccountantIDForPayeable(AccountantID, IDPaymentFile, ProcessType).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        )

    }

    const create = () => {
        AccountantIDForPayeable.setBean({

        });
        setModal({ ...modal, "view": true });
    }
    // const deleteItem = () => {
    //     AccountantIDForPayeable.deleteItemVoid(entailment.bean.IDEntailment).then(
    //         (resp: any) => {
    //             getLista();
    //             setModalC({ ...modalC, "name": `Agregar Nivel Jerárquico de Empleo`, "view": false });
    //         }
    //     )

    // }
    const editaItem = () => {
        //console.log(entailment.bean);
        AccountantIDForPayeable.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [


        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Paquete de Pago', property: 'PaymentFileName', visible: true },
        { title: 'Código', property: 'AccountantIDStr', visible: true },
        { title: 'Consolida Terceros', property: 'RequiresConsolidateThird', visible: true },
        { title: 'Generar Cuenta por Pagar', property: 'Payeable', visible: true },


    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar ${AccountantIDForPayeable.bean.Name}`, "view": true }) } },
            // { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Cuentas por Proceso">
            <div className="row">
                <div className="col-md-12">
                    <div className="row">
                        <div className="col-md-4">
                            <label>Cuenta</label>
                            <SelectAccountantTree idAccountant={AccountantID} onChange={(e) => { setAccountantID({ ...AccountantID, "AccountantID": e.JsonCode }) }} />
                        </div>
                        <div className="col-md-4">
                            <Selecttofile label='Tipo de Paquete de Pago' idSelector={IDPaymentFile} onChange={(e: any) => { setIDPaymentFile(e) }} />
                        </div>
                        <div className="col-md-4">
                            <SelectTypeProcees label='Tipo de Proceso' idSelector={ProcessType} onChange={(e: any) => { setProcessType(e) }} />
                        </div>
                        <div className="col-md-4 mt-4 p-2">
                            <BasicButton value="Buscar" icon="ri-file-add-line" eventClick={getLista} ></BasicButton>
                        </div>
                    </div>
                    <BasicTable body={lista} head={head} rowSet={AccountantIDForPayeable.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            <div className="col-md-2">
                                <strong>Agregar / Editar </strong>
                            </div>
                            <div className="col-md-10">
                                <ButtonAccountantTree
                                    id={0}
                                    idAccountantIDType={1}
                                    bean={AccountantIDForPayeable.bean}
                                    updateEvent={() => { editaItem() }}
                                />
                            </div>

                        </div>
                    </Modal>
                    {/* <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {AccountantIDForPayeable.bean.Name}</strong>
                    </ModalConfirm> */}
                </div>

            </div>
        </BasicPage>
    )
}